import { FC } from 'react';

import Conclusion from '../../../Shared/Conclusion';

import { Product } from '../../../../types/tour';

export type Props = {};

export const Step8: FC<Props> = () => {
  return <Conclusion product={Product.Chat} />;
};
